import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SvgIconSizeMod } from 'models/layout-mod.model';
import { NgSwitch, NgSwitchCase } from '@angular/common'

@Component({
  selector: '[svgIcon]',
  templateUrl: './svg-icon.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    NgSwitch,
    NgSwitchCase
  ],
  styleUrls: ['./svg-icon.component.scss']
})
export class SvgIconComponent {
  @Input() icon!: string;

  @Input() iconSize?: SvgIconSizeMod;

  size = SvgIconSizeMod.DEFAULT;

  constructor() { }

  ngOnInit(): void {
    if (this.iconSize) {
      this.size = this.iconSize;
    }
  }

}
